var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"fill-height",attrs:{"to":{
    name: 'GalleryImage',
    params: { gallery: _vm.gallery, image: _vm.image, lazySrc: _vm.imageUrl },
  }}},[_c('v-img',{attrs:{"src":_vm.imageUrl,"contain":"","aspect-ratio":1 / 1},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey"}})],1)]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }